export default "__VITE_ASSET__5d2867a5__"